import { render, staticRenderFns } from "./ProductText.vue?vue&type=template&id=de62c778"
import script from "./ProductText.vue?vue&type=script&lang=js"
export * from "./ProductText.vue?vue&type=script&lang=js"
import style0 from "./ProductText.vue?vue&type=style&index=0&id=de62c778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports